import {
	GET_UPLOAD_JOB_DETAILS_REQUEST,
	GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS,
	GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED,
	GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR,
} from "../types"

const initialState = {
	isLoading: false,
	uploadJobDetails: {},
}
const bifrostUploadJobDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_UPLOAD_JOB_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				uploadJobDetails: action.payload,
			}
		case GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				uploadJobDetails: {},
			}
		case GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR:
			return initialState

		default:
			return state
	}
}

export default bifrostUploadJobDetailsReducer
